/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';
var searchModel = require('../models/search.model').getInstance();
var Mixin = require('./mixin');
var config = {
    setMethods: ['create', 'update', 'delete'],
    getMethods: ['read'],
};

module.exports = new Mixin({
    init: function() {
        if (this.widget instanceof Odigeo.Widget) {
            this.listenTo(this.widget, 'construct', this.fetchFromSearchModel);
        }
        this.listenTo(searchModel, 'sync:fetch', this.fetchFromSearchModel);
        this.listenTo(searchModel, 'clear', this.clear);
        this.listenTo(searchModel, 'errors', this.setErrors);
        this.listenTo(searchModel, 'change', function(model, options) {
            if (!Odigeo._.isEqual(options.modelId, this.getModelId()) && !options.silent) {
                this.trigger('changeSearchModel', model, options);
            }
        });
        this.on('add remove', this.save);
        this.bindCustomEvents(searchModel);
    },

    listenSearchModelProperty: function(prop, callback) {
        this.listenTo(searchModel, 'change:' + prop, callback);
    },

    setSearchModelProperty: function(prop, value) {
        searchModel.set(prop, value);
    },

    setErrors: function(errors, opts) {
        if (Odigeo._.isArray(errors)) {
            this.errors = errors;
        }

        if (!opts.silent) {
            this.trigger('error', this.errors);
        }
    },

    getErrors: function() {
        return Odigeo._.isArray(this.errors) ? this.errors : [];
    },

    sync: function(method, model, options) {
        options = options || {};

        if (Odigeo._.includes(config.getMethods, method)) {
            this.getModelMethod(options);
        }

        if (Odigeo._.includes(config.setMethods, method) && !options.searchModelSilent) {
            this.setModelMethod(model, options);
        }

        return $.Deferred().resolve().promise();
    },

    save: function(key, val, options) {
        if (this instanceof Odigeo.Model) {
            return Odigeo.Model.prototype.save.call(this, key, val, options);
        } else if (this instanceof Backbone.Model) {
            return Backbone.Model.prototype.save.call(this, key, val, options);
        } else {
            return this.sync('update', this, options);
        }
    },

    fetchFromSearchModel: function() {
        this.fetch.apply(this, arguments)
            .then(Odigeo._.bind(this.trigger, this, 'sync:fetch'));

        return this;
    },

    getModelMethod: function(options) {
        // options.sucess is the backbone callback to set the results in the model
        // used by the Backbone.Model.prototype.fetch
        options.success(this.getOriginalData());
    },

    setModelMethod: function(model, options) {
        searchModel.set(
            this.pushParse(model, this.getOriginalData()),
            Odigeo._.extend({modelId: this.getModelId()}, options)
        );
    },

    parse: function(searchParams) {
        return Odigeo._.pick(searchParams, Odigeo._.keys(this.defaults));
    },

    pushParse: function() {
        return Odigeo._.pick(this.toJSON(), Odigeo._.keys(this.defaults));
    },

    getModelId: function() {
        return Odigeo._.result(this.widget, 'id');
    },

    getOriginalData: function() {
        return searchModel.toJSON();
    },

    bindCustomEvents: function() {
        // Optional init Hook
    },

    getDates: function() {
        return searchModel.getDates();
    },
});
